import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

const MILESTONES = {
  3: { icon: "🔥", label: "EN RACHA", color: "#f97316" },
  5: { icon: "⚡", label: "IMPARABLE", color: "#8b5cf6" },
  10: { icon: "👑", label: "MAESTRO DE LAS TRIVIAS", color: "#eab308" },
};

const MilestoneToast = ({ streak }) => {
  const [visible, setVisible] = useState(true);
  const config = MILESTONES[streak];

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 2200);
    return () => clearTimeout(timer);
  }, []);

  if (!config || !visible) return null;

  return (
    <Overlay>
      <Card $color={config.color}>
        <Icon>{config.icon}</Icon>
        <Label>{config.label}</Label>
      </Card>
    </Overlay>
  );
};

export default MilestoneToast;

const scaleIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.4) translateY(30px);
  }
  60% {
    opacity: 1;
    transform: scale(1.1) translateY(-6px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.85);
  }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1002;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.12);
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 28px 36px;
  border-radius: 24px;
  background: #ffffff;
  border: 4px solid ${({ $color }) => $color};
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  animation: ${scaleIn} 0.45s cubic-bezier(0.22, 1, 0.36, 1) forwards,
    ${fadeOut} 0.35s ease-in 1.85s forwards;
`;

const Icon = styled.span`
  font-size: 58px;
  line-height: 1;
`;

const Label = styled.span`
  font-size: 22px;
  font-weight: 900;
  color: #111827;
  text-align: center;
  letter-spacing: 0.04em;
`;
